import css from './Dialog.module.scss';
import useTNC from './useTNC';
import getLocal from '@/app/utils/getLocal';

export default function DialogTerm({ callback }: any) {
    const { locale } = getLocal();
    const tnc = useTNC(locale);

    return (
        <div className={css.DialogTerm}>
            <div className="content">
                <p className="close" onClick={callback}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                        <path
                            d="M5.20117 4.75L16.2512 15.8M16.2512 4.75L5.20117 15.8"
                            stroke="white"
                            strokeWidth="1.53"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </p>
                {tnc && (
                    <>
                        <div className="ef-title">{tnc.title}</div>
                        <div className="divider"></div>
                        <div className="ef-text-content">
                            {tnc.content.map((item, ind) => (
                                <p key={ind} dangerouslySetInnerHTML={{ __html: item }}></p>
                            ))}
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}
